import React, { useEffect } from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";
import { toast } from "react-toastify";

const DashboardRoute = ({ element }) => {
  const user = Cookies.get("fytn_user");
  const userObj = user ? JSON.parse(user) : null;

  useEffect(() => {
    if (userObj?.userRole === "ADMIN") {
      toast.error("Not accessible");
    }
  }, [userObj]);

  if (userObj?.userRole === "ADMIN") {
    return <Navigate to="/admin" replace />;
  } else {
    return element;
  }
};

export default DashboardRoute;
